import { styled, FormGroup as MuiFormGroup } from '@mui/material';

export const FormGroup = styled(MuiFormGroup)`
  min-width: 140px;

  @media (max-width: 1023px) {
    min-width: unset;
    width: 100%;
  }
`;
